import { useRef, useState } from 'react';
import { HiChevronDown, HiChevronUp, HiOutlineInformationCircle } from 'react-icons/hi';
import { useSelector } from 'react-redux';

import { AdditionalContentFieldComponent } from '@core/blocks/edu-flow-2/utils/additionalContentFieldTypeDictionary';
import usePageHeadingParser from '@core/blocks/edu-flow/components/Page/hooks/usePageHeadingParser';
import { selectDcsCategories, selectDcsSubjects } from '@core/reducers/dcsSlice';
import cn from '@core/utils/classNames';

import styles from './InfoPanelMobile.module.css';

const InfoPanelMobile: AdditionalContentFieldComponent = ({ field }) => {
  const [isOpen, setIsOpen] = useState(false);
  const parseDescription = usePageHeadingParser();
  const dcsCategory = useSelector(selectDcsCategories)[0];
  const dcsSubject = useSelector(selectDcsSubjects)?.[0];

  const contentRef = useRef<HTMLParagraphElement>(null);

  const parsingCategoryText =
    dcsCategory === 'General'
      ? field?.content?.replace('{dcsCategories}', 'any <strong>General</strong> category')
      : field?.content?.replace('{dcsCategories}', '<strong>{dcsCategories}</strong>');
  const parsingCategoryAndSubjectText = !dcsSubject
    ? parsingCategoryText?.replace('{dcsSubjects}', 'any <strong>General</strong> subject')
    : parsingCategoryText?.replace('{dcsSubjects}', '<strong>{dcsSubjects}</strong>');

  // we want to remove break tags on mobile to save space.
  const parsedTextWithoutBreaks = parsingCategoryAndSubjectText?.replace(/<br\s*\/?>/gi, ' ');

  const parsedText = parseDescription(parsedTextWithoutBreaks);

  const OpenCloseIcon = isOpen ? HiChevronUp : HiChevronDown;

  const doesContentOverflow = Number(contentRef?.current?.scrollHeight) > 48;

  return (
    <div className={styles.contentCta}>
      <div className={styles.ctaContainer}>
        <div className={styles.ctaHeading}>
          <HiOutlineInformationCircle size={24} /> <p>{field.heading}</p>
          {doesContentOverflow && (
            <div className={styles.expandButton}>
              <button type="button" onClick={() => setIsOpen(!isOpen)}>
                <OpenCloseIcon size={24} />
              </button>
            </div>
          )}
        </div>
        {field.content && (
          <p
            ref={contentRef}
            className={cn(
              styles.ctaDescription,
              isOpen && styles.expandContent,
              doesContentOverflow && styles.hideContent
            )}
            dangerouslySetInnerHTML={{
              __html: parsedText,
            }}
          />
        )}
      </div>
    </div>
  );
};

export default InfoPanelMobile;
